import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { IntroComponent } from './intro.component';
import { IntroTextComponent } from './intro-text.component';
import { IntroButtonComponent } from './intro-button.component';
import { IntroImgComponent } from './intro-img.component';

@NgModule({
    imports: [
        CommonModule,
        LazyLoadImageModule
    ],
    declarations: [
        IntroComponent,
        IntroTextComponent,
        IntroButtonComponent,
        IntroImgComponent
    ],
    exports: [
        IntroComponent,
        IntroTextComponent,
        IntroButtonComponent,
        IntroImgComponent
    ],
})
export class IntroModule {
}
